import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { DeleteConfirmationComponent } from '../../shared/modals/delete-confirmation/delete-confirmation.component';
import { DeleteConfirmationData } from '../../shared/models/modal-data.model';
import { ModalService } from '../../shared/services/modal.service';

export interface UnsavedChangesComponent {
  hasUnsavedChanges(): boolean;
  saveForNavigation(): Promise<boolean>;
}

/**
 * Blocks leaving a page with unsaved form changes. Prompts to save first; "Verwerfen" (or
 * closing the dialog) discards the changes and allows navigation to proceed.
 */
export const unsavedChangesGuard: CanDeactivateFn<UnsavedChangesComponent> = component => {
  if (!component.hasUnsavedChanges()) {
    return true;
  }

  const modalService = inject(ModalService);
  const data: DeleteConfirmationData = {
    title: 'Änderungen speichern',
    message: 'Diese Seite enthält ungespeicherte Informationen, wollen Sie diese erst speichern?',
    confirmText: 'Speichern',
    cancelText: 'Verwerfen',
  };

  return modalService
    .open(DeleteConfirmationComponent, data)
    .then(confirmed => (confirmed ? component.saveForNavigation() : true))
    .catch(() => true);
};
